const e=function(e){return(arguments.length>1&&void 0!==arguments[1]?arguments[1]:[]).reduce(((n,t)=>(t in e&&(n[t]=e[t]),n)),{})},n=(e,n)=>Object.keys(e).reduce(((t,c)=>(n(e[c],c,e)&&(t[c]=e[c]),t)),{});export{e as pick,n as pickBy};
//# sourceMappingURL=pick.min.mjs.map
